import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import IncidentDiscardedReasonController from 'redpoints-restapi-connector/controller/IncidentDiscardedReasonController';

import {
  CONNECTOR_REQUEST,
  REPORTED_INCIDENTS_CLEAR,
  REPORTED_INCIDENTS_CLEAR_FILTERS,
  REPORTED_INCIDENTS_FETCH_DISCARD_REASONS,
  REPORTED_INCIDENTS_SET_DISCARD_REASON,
  REPORTED_INCIDENTS_SET_FORM,
  REPORTED_INCIDENTS_SET_ON_REVIEW,
} from './actionTypes';

export const reportedIncidentsClear = () => ({
  type: REPORTED_INCIDENTS_CLEAR,
});

export const reportedIncidentsClearFilters = () => ({
  type: REPORTED_INCIDENTS_CLEAR_FILTERS,
});

export const reportedIncidentsSetOnReview = ({ onReview }) => ({
  type: REPORTED_INCIDENTS_SET_ON_REVIEW,
  payload: { onReview },
});

export const reportedIncidentsSetForm = ({ form }) => ({
  type: REPORTED_INCIDENTS_SET_FORM,
  payload: { form },
});

export const reportedIncidentsFetchDiscardReasons = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: REPORTED_INCIDENTS_FETCH_DISCARD_REASONS,
    connectorMethod: IncidentDiscardedReasonController.list,
    expectedStatus: HttpStatus.OK,
  },
});

export const reportedIncidentsSetDiscardReason = ({ discardReasonId }) => ({
  type: REPORTED_INCIDENTS_SET_DISCARD_REASON,
  payload: { discardReasonId },
});
